import { CommonModule } from "@angular/common";
/* eslint-disable eqeqeq*/
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { IonicModule } from "@ionic/angular";

@Component({
  selector: "google-data-info",
  imports: [CommonModule, IonicModule, TranslateModule],
  standalone: true,
  templateUrl: "./google-data-info.component.html",
  styleUrls: ["./google-data-info.component.scss"],
})
export class GoogleDataInfo {
  @Input() playersCount: number;

  constructor() {}
}
